import Vue from 'vue'
import utils from '@/utils/common'
import $ from 'jquery'
Vue.directive("swiper", {
	inserted: function(el, binding) {
		var th = this;
		console.log(th)
		$(el).on("click", ".swiper-slide", () => {
			var args = arguments;
			binding.value.apply(th, args);
		});
	},
});
